import React from 'react';

const NotesSection = () => {
    const notes = [
        {
            id: 1,
            title: "Core Web Vitals in Ecommerce",
            text: "LCP (Largest Contentful Paint) is the most critical metric for ecommerce. Prioritize image optimization, CDN usage, and critical CSS inlining. A 100ms improvement in LCP can increase conversion by 1-2%."
        },
        {
            id: 2,
            title: "Checkout Optimization Patterns",
            text: "Reduce friction by implementing auto-fill, address validation, and guest checkout by default. Every additional form field decreases conversion. Consider one-page checkout patterns and wallet integrations (Apple Pay, Google Pay)."
        },
        {
            id: 3,
            title: "Headless Architecture Decisions",
            text: "Headless isn't always the answer. Evaluate based on team size, budget, and complexity needs. For most mid-market retailers, a well-optimized monolith with modern frontend practices delivers better ROI than a full headless setup."
        },
        {
            id: 4,
            title: "Caching Strategies That Matter",
            text: "Implement edge caching for static assets, full-page caching for catalog pages, and ESI (Edge Side Includes) for dynamic blocks. Cache invalidation strategies are more important than cache duration settings."
        }
    ];

    return (
        <section className="section notes-section">
            <div className="container">
                <h2 className="section-title">Engineering Notes</h2>
                <p className="section-subtitle">
                    Insights and lessons learned from building ecommerce experiences at scale
                </p>

                <div className="notes-grid grid grid--2">
                    {notes.map((note) => (
                        <div key={note.id} className="note-card">
                            <h3 className="note-card__title">{note.title}</h3>
                            <p className="note-card__text">{note.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default NotesSection;